import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'flux/utils';
import ListView from '../Common/ListView.react';

import ROLES from '../../constants/Roles';
import buildContextMenu from '../Common/BuildContextMenu';
import IconPerson from 'material-ui/svg-icons/action/perm-identity';
import IconCompliance from 'material-ui/svg-icons/action/done-all';
import IconEnrolments from 'material-ui/svg-icons/social/school';
import IconSettings from 'material-ui/svg-icons/action/settings';

import UserActions from '../../actions/UserActionCreator';
import UserSkillStore from '../../stores/UserSkillStore';
import UserSkillListItem from './UserSkillListItem';
import { openDialog } from '../../actions/DialogActionCreator';
import { UserDialogs } from '../../constants/Dialogs';
import UserSkillDialog from './UserSkillDialog';

const getMenuItems = (id) => [
    {
        link: `/dashboard/user/${id}`,
        icon: <IconPerson />,
        label: 'User profile'
    },
    { type: 'divider' },
    {
        link: `/dashboard/user/${id}/compliance`,
        icon: <IconCompliance />,
        label: 'Compliance'
    },
    {
        link: `/dashboard/courses/enrolments/user/${id}`,
        icon: <IconEnrolments />,
        label: 'Enrolments'
    },
    { type: 'divider' },
    {
        link: `/dashboard/user/${id}/settings`,
        icon: <IconSettings />,
        label: 'Settings',
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
];

const sortOptions = [
    { label: 'Name',          value: 'skillName'    },
    { label: 'Date Acquired', value: 'dateAcquired' },
    { label: 'Date Expired',  value: 'dateExpired'  }
];

class UserSkillList extends Component {

    componentDidMount() {
        this.sort = this.sort.bind(this);
        this.search = this.search.bind(this);
        UserActions.getSkillsByUser(this.props.userId);
    }

    render() {
        const actions = buildContextMenu(this.props.menuItems || getMenuItems(this.props.userId), this.context.auth);
        const isAdmin = this.context.auth.isAdmin();

        return (
            <div>
                <ListView
                    title="Skills"
                    items={this.state.skills}
                    itemDecorator={UserSkillListItem}
                    itemProps={{userId: this.props.userId}}
                    backButton={true}
                    actions={actions}
                    sortOptions={sortOptions}
                    sortAction={this.sort}
                    searchAction={this.search}
                    newEntityAction={isAdmin && (() => openDialog(UserDialogs.USER_SKILL_DIALOG))}
                />
                {isAdmin && <UserSkillDialog userId={this.props.userId} /> }
            </div>
        );
    }

    sort({sort}) {
        let sortCriteria, sortMapCriteria, order;
        switch (sort) {
            case 'name':
                sortCriteria = (a, b) => a.value.localeCompare(b.value);
                sortMapCriteria = (el, i) => ({ index: i, value: el.skillName });
                order = 'asc';
                break;
            case 'dateAcquired':
                sortCriteria = (a, b) => (b.value - a.value);
                sortMapCriteria = (el, i) => ({ index: i, value: Date.parse(el.dateAcquired) });
                order = 'desc';
                break;
            case 'dateExpired':
                sortCriteria = (a, b) => (a.value - b.value);
                sortMapCriteria = (el, i) => ({ index: i, value: Date.parse(el.dateExpired) });
                order = 'asc';
                break;
            default:
                sortCriteria = (a, b) => (a.value - b.value);
                sortMapCriteria = (el, i) => ({ index: i, value: el[sort] });
        }
        const mapped = this.state.skills.map(sortMapCriteria);
        mapped.sort(sortCriteria);
        const skills = mapped.map((el) => this.state.skills[el.index]);
        this.setState({skills});
        UserActions.getSkillsByUser(this.props.userId, {sort, order});
    }

    search(searchText) {
        this.timeout && clearTimeout(this.timeout);
        if (!!searchText && searchText.length > 2) {
            this.timeout = setTimeout(() => { UserActions.searchSkillsByUser(this.props.userId, searchText); }, 500);
        }
    }
}

UserSkillList.getStores = () => ([UserSkillStore]);
UserSkillList.calculateState = (prevState, {userId}) => ({
    ...prevState,
    skills: UserSkillStore.get(userId) || [],
});

UserSkillList.propTypes = {
    userId: PropTypes.number.isRequired,
    menuItems: PropTypes.array
};

UserSkillList.contextTypes = {
    auth:   PropTypes.object.isRequired
};

export default Container.create(UserSkillList, {withProps: true});
